package com.gsb.vyapar.bhagya.datasource.network.request


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GitHubUploadBody(
    @SerialName("branch")
    val branch: String?,
    @SerialName("content")
    val content: String?,
    @SerialName("message")
    val message: String?
)